import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles } from '../styles.ts';
import { MarketConditionGraphsPageProps } from '../types.ts';
import { MARKET_CONDITION_GRAPH_TITLES } from '../utils/marketConditionGraphImages.tsx';

const styles = StyleSheet.create({
  grid: {
    flexDirection: 'column',
    gap: 8,
  },
  card: {
    border: '1px solid #D9DEE7',
    borderRadius: 2,
    padding: 8,
    height: 160,
  },
  title: {
    ...fontStyles.h5,
    marginBottom: 2,
  },
  image: {
    width: '100%',
    height: 130,
    objectFit: 'fill',
  },
});

export const MarketConditionGraphsPage = ({
  subjectAddress,
  tkv2ChartImages: { marketConditionGraphImages },
}: MarketConditionGraphsPageProps) => {
  if (!marketConditionGraphImages.some(Boolean)) return null;

  return (
    <>
      {[0, 4].map((start) => {
        const pageTitles = MARKET_CONDITION_GRAPH_TITLES.slice(start, start + 4);
        if (pageTitles.length === 0) return null;

        return (
          <Tkv2PDFPage key={start} title="Market analysis" address={subjectAddress}>
            <Text style={fontStyles.h3}>Sales Market Analysis</Text>
            <View style={styles.grid}>
              {pageTitles.map((title, index) => {
                const image = marketConditionGraphImages[start + index];

                return (
                  <View key={title} style={styles.card}>
                    <Text style={styles.title}>{title}</Text>
                    {image && <Image src={image} style={styles.image} />}
                  </View>
                );
              })}
            </View>
          </Tkv2PDFPage>
        );
      })}
    </>
  );
};
